import { STANDALONE_PATHS } from '@pass-frontend/common/constants/paths';
import { env } from '@pass-frontend/features/configuration/util';

export interface FooterItems {
  labelKey: string;
  type: string;
  dataUIElementName: string;
  redirectURL?: string;
  openInSameTab?: boolean;
  isInternalLink?: boolean;
}

export interface FooterDataProps {
  copyRightKey: string;
  items: Array<FooterItems>;
}

const { FF_ENABLE_OPTUM_TERMS_AND_PRIVACY } = env();

export const commercialFooterProps: FooterDataProps = {
  copyRightKey: 'footer.copyRightText',
  items: [
    {
      labelKey: 'footer.privacyPolicyLabelText',
      type: 'link',
      redirectURL: FF_ENABLE_OPTUM_TERMS_AND_PRIVACY
        ? STANDALONE_PATHS.PRIVACY_POLICY
        : 'https://www.rallyhealth.com/corporate/privacy/en-us',
      dataUIElementName: 'privacy-policy',
    },
    {
      labelKey: 'footer.termsOfUseLabelText',
      type: 'link',
      redirectURL: FF_ENABLE_OPTUM_TERMS_AND_PRIVACY
        ? STANDALONE_PATHS.TERMS_OF_USE
        : 'https://www.rallyhealth.com/corporate/terms/en-us',
      dataUIElementName: 'terms-of-use',
    },
  ],
};
export const governmentFooterProps: FooterDataProps = {
  copyRightKey: 'footer.copyRightText',
  items: [
    {
      labelKey: 'footer.privacyPolicyLabelText',
      type: 'link',
      redirectURL: FF_ENABLE_OPTUM_TERMS_AND_PRIVACY
        ? STANDALONE_PATHS.PRIVACY_POLICY
        : 'https://www.rallyhealth.com/corporate/privacy/en-us',
      dataUIElementName: 'privacy-policy',
    },
    {
      labelKey: 'footer.termsOfUseLabelText',
      type: 'link',
      redirectURL: FF_ENABLE_OPTUM_TERMS_AND_PRIVACY
        ? STANDALONE_PATHS.TERMS_OF_USE
        : 'https://www.rallyhealth.com/corporate/terms/en-us',
      dataUIElementName: 'terms-of-use',
    },
  ],
};
